import { Model } from 'pinia-orm';

export default class Perk extends Model {

    static get entity () {
        return 'perks';
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr({}),
            value: this.attr({}),
            image_url: this.attr(''),
            pivot: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null)
        }
    }
}
